import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { ButtonBase, Dialog, IconButton, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { BarChartCard, LineChartCard, PieChartCard } from './ChartCard';
import { SearchBar } from '../SearchBar';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { AppHelper } from '../../../helpers/AppHelper';
import { Helper } from '../../helpers/Helper';
import { CommonTheme } from '../../../styles/Styles';
import FullscreenOutlinedIcon from '@material-ui/icons/FullscreenOutlined';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

function getPercentage(value, total) {
  const totalNum = Number(total)
  if (!totalNum || isNaN(totalNum)) return 0
  const percentage = (Number(value) / totalNum) * 100
  return Number(percentage.toFixed(1))
}

function ChartTabScrollButton(props) {
  const { direction, onClick, visible, className } = props
  const disabled = !visible
  return (
    <ButtonBase
      className={[className, css(Styles.scrollButton, disabled && Styles.scrollButtonDisabled)].filter(Boolean).join(' ')}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      disableRipple={disabled}
    >
      {direction === 'left' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
    </ButtonBase>
  )
}

export class TabChartCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      tableSearchQuery: '',
      selectedExpansionGroup: 'all',
    };
  }

  handleTabChange = (event, tab, {chartType}) => {
    if(this.props.selectedTabData && this.props.handleTabChange) {
      this.props.handleTabChange(tab, chartType)
    }
  }

  openModalForViewDetails() {
    this.setState({
      modalOpen: true,
      tableSearchQuery: '',
      selectedExpansionGroup: 'all',
    });
  }

  onCloseModal() {
    this.setState({
      modalOpen: false,
      tableSearchQuery: '',
      selectedExpansionGroup: 'all',
    });
  }

  onTableSearch(searchText = '') {
    this.setState({ tableSearchQuery: searchText })
  }

  handleExpansionGroupChange(event, val) {
    this.setState({ selectedExpansionGroup: (val && val.key) || 'all' })
  }

  fullWidthCondition(fullWidthDialog) {
    if (fullWidthDialog) {
      return true
    }
    if (window.innerWidth && window.innerWidth < 480) {
      return true
    }
    return false
  }

  getSelectedTabChartData() {
    const {chartType, tabsData, selectedTabData} = this.props
    const tabs = tabsData && tabsData[chartType]
    if (!tabs || tabs.length === 0 || !selectedTabData) {
      return null
    }
    const selectedTabIndex = Math.min(
      Math.max(0, selectedTabData[chartType] || 0),
      tabs.length - 1
    )
    return tabs[selectedTabIndex] || null
  }

  getSelectedTabIndex() {
    const {chartType, tabsData, selectedTabData} = this.props
    const tabs = tabsData && tabsData[chartType]
    if (!tabs || tabs.length === 0 || !selectedTabData) {
      return 0
    }
    return Math.min(
      Math.max(0, selectedTabData[chartType] || 0),
      tabs.length - 1
    )
  }

  isDataAvailable() {
    const {chartData} = this.props
    let isAvailable = false
    if(chartData && chartData.datasets && chartData.datasets[0] && Array.isArray(chartData.datasets[0].data) && chartData.datasets[0].data.length > 0) {
      isAvailable = true
    }
    return isAvailable
  }

  renderModal() {
    const {chartType, isMultiChart} = this.props

    const selectedTabChartData = this.getSelectedTabChartData()
    if (!selectedTabChartData) {
      return null
    }
    const currentChartData = JSON.parse(JSON.stringify(this.props.chartData))

    let sumOfData = 0

    if(currentChartData && currentChartData.datasets && currentChartData.datasets.length > 0 && currentChartData.datasets[0].data) {
      const data =  currentChartData.datasets[0].data
      if(selectedTabChartData.showTotal) {
        sumOfData = data.reduce((acc, num) => acc + Number(num), 0)
      }
      if(selectedTabChartData.showPercent) {
        currentChartData.datasets[0].data = data.map((item)=>(`${item} (${getPercentage(item, this.props.percentTotal)}%)`))
      }
    }

    let headers = []
    if( selectedTabChartData && Array.isArray(selectedTabChartData.headers) && selectedTabChartData.headers.length > 0 ) {
      headers =  selectedTabChartData.headers
    }
    let rows = []
    if(currentChartData && currentChartData.labels && this.isDataAvailable()) {
      if((!isMultiChart && (chartType === 'pieChart')) || (isMultiChart && (selectedTabChartData.type === 'pieChart'))) {
        currentChartData.labels = currentChartData.labels.map((label,index) => {
          let newLabel
          if(currentChartData.expandedLabels && index in currentChartData.expandedLabels) {
            newLabel = currentChartData.expandedLabels[index]
          } else {
            newLabel = label.replace(/\s*\(\d+\)$/, '')
          }
          return newLabel
        }
        );
      }

      rows = currentChartData.labels.map((key, index) => [key, currentChartData.datasets[0].data[index]]).slice(0,100)
    }

    const expansionGroups = (selectedTabChartData && Array.isArray(selectedTabChartData.expansionGroups) && selectedTabChartData.expansionGroups.length > 0)
      ? selectedTabChartData.expansionGroups
      : null
    const selectedGroupKey = (expansionGroups && expansionGroups.some((group) => group && group.key === this.state.selectedExpansionGroup))
      ? this.state.selectedExpansionGroup
      : 'all'
    let groupedRows = rows
    if (expansionGroups && selectedGroupKey !== 'all') {
      const selectedGroup = expansionGroups.find((group) => group && group.key === selectedGroupKey)
      const allowed = new Set((selectedGroup && Array.isArray(selectedGroup.keys)) ? selectedGroup.keys : [])
      groupedRows = rows.filter((row, index) => {
        const rowKey = (currentChartData && currentChartData.keys && currentChartData.keys[index]) || (row && row[0])
        return allowed.has(rowKey)
      })
    }

    const searchColumns = (selectedTabChartData && Array.isArray(selectedTabChartData.searchColumns)) ? selectedTabChartData.searchColumns : []
    const isSearchEnabled = searchColumns.length > 0
    const searchQuery = (this.state.tableSearchQuery || '').trim().toLowerCase()
    const searchColumnIndexes = searchColumns
      .map((columnName) => headers.indexOf(columnName))
      .filter((index) => index > -1)
    const filteredRows = (isSearchEnabled && searchQuery && searchColumnIndexes.length > 0)
      ? groupedRows.filter((row) => {
        return searchColumnIndexes.some((columnIndex) => {
          const cellValue = (row && row[columnIndex] !== undefined && row[columnIndex] !== null) ? String(row[columnIndex]) : ''
          return cellValue.toLowerCase().includes(searchQuery)
        })
      })
      : groupedRows
    const searchPlaceholder = (selectedTabChartData && selectedTabChartData.searchPlaceholder) ? selectedTabChartData.searchPlaceholder : 'Search'
    const groupOptions = expansionGroups
      ? [{ key: 'all', label: 'All Tags' }, ...expansionGroups]
      : []
    const selectedGroup = groupOptions.find((group) => group && group.key === selectedGroupKey) || groupOptions[0]

    const fullWidthDialog = (this.props.fullWidthDialog && window.innerWidth > 480)
    return(<Dialog
      open={this.state.modalOpen}
      fullWidth={true}
      fullScreen={this.fullWidthCondition(fullWidthDialog)}
      classes={{
        root: css(Styles.customRoot),
        paper: css(Styles.customPaper, AppHelper.isDialogScrollbarEnabled() && AppStyles.dialogScrollbar),
      }}
      BackdropProps={fullWidthDialog && { style: { backgroundColor: 'unset' } }}
      maxWidth='md'
    >
      <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
        <div className={css(Styles.modalTitle)}>{ selectedTabChartData && selectedTabChartData.title}</div>
        <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
          <svg className={css(Styles.modalCloseIcon)} viewBox='0 0 36 36'>
            <path d='M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z'></path>
          </svg>
        </button>
      </div>
      <div className={css(Styles.modalContent)}>
        {(isSearchEnabled || expansionGroups) && <div className={css(Styles.searchContainer)}>
          {isSearchEnabled && <div className={css(Styles.searchBarWrap)} onSubmitCapture={(e) => e.preventDefault()}>
            <SearchBar
              hint={searchPlaceholder}
              searchText={this.state.tableSearchQuery}
              onSearch={this.onTableSearch.bind(this)}
              autoRefresh
              debounceDuration={200}
              autoFocus={false}
              hideFiltersContainer
            />
          </div>}
          {expansionGroups && <Autocomplete
            className={css(Styles.groupSelect)}
            disableClearable
            options={groupOptions}
            value={selectedGroup}
            onChange={this.handleExpansionGroupChange.bind(this)}
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => option.key === value.key}
            PopperProps={{
              placement: 'bottom-start',
              modifiers: {
                flip: { enabled: false },
              },
            }}
            classes={{
              popupIndicator: css(Styles.groupSelectPopupIndicator),
              popper: css(Styles.groupSelectPopper),
              option: css(Styles.groupSelectOption),
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant='standard'
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                  readOnly: true,
                  classes: {
                    root: css(Styles.groupSelectInputRoot),
                  },
                }}
              />
            )}
          />}
        </div>}
        <TableContainer className={css(Styles.modalTableContainer)}>
          {(headers && headers.length > 0 && filteredRows && filteredRows.length > 0)  ? (<Table stickyHeader>
            <TableHead>
              <TableRow>
                {headers.map((header, index) => (
                  <TableCell key={index}  className={index === 0 ? css([Styles.cellHead, Styles.firstColumn]) : css(Styles.cellHead)}>{
                    (sumOfData > 0 && index === 1) ? `${header} (${sumOfData})` : header
                  }</TableCell>
                ))}
                {selectedTabChartData.tableRowActions && <TableCell className={css(Styles.cellHead)}></TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {row.map((cell, cellIndex) => {
                    return(
                      <TableCell key={cellIndex}
                        className={cellIndex === 0 ? (css([Styles.cellBody, Styles.modalFirstColumn, (selectedTabChartData.enableFilter && Styles.drillDownEnabledCell)])) : css(Styles.cellBody)}
                        onClick={ cellIndex === 0 && selectedTabChartData.enableFilter && selectedTabChartData.filterClickHandler  && (()=>selectedTabChartData.filterClickHandler({selectedTabKey: selectedTabChartData.key, key: (currentChartData && currentChartData.keys && currentChartData.keys[rows.indexOf(row)]), label: cell}))}
                      >
                        {cell}
                      </TableCell>
                    )}
                  )}
                  {selectedTabChartData.tableRowActions && <TableCell className={css(Styles.cellBody, Styles.actionsColumn)}>
                    {selectedTabChartData.tableRowActions({selectedTabKey: selectedTabChartData.key, key: (currentChartData && currentChartData.keys && currentChartData.keys[rows.indexOf(row)]), label: row[0], header: headers[0]})}
                  </TableCell>}
                </TableRow>
              ))}
            </TableBody>
          </Table>) : (<div className={css(Styles.emptyViewContainer)}><p className={css(Styles.emptyViewText)}>{Helper.getString('noDataAvailable')}</p></div>)}
        </TableContainer>
      </div>
    </Dialog>)
  }

  render() {
    const {chartType, tabsData, chartData, xLabelsDifference, selectedTabData, showDataLabels, isMultiChart, chartActions } = this.props

    if(!chartType || !tabsData || !chartData || !selectedTabData) {
      return null
    }

    const selectedTabIndex = this.getSelectedTabIndex()
    const selectedTabChartData = this.getSelectedTabChartData()
    if (!selectedTabChartData) {
      return null
    }
    const chartInstanceKey = (selectedTabChartData && selectedTabChartData.key) || selectedTabIndex

    const currentChartData = JSON.parse(JSON.stringify(chartData))

    if((!isMultiChart && (chartType === 'pieChart')) || (isMultiChart && (selectedTabChartData.type === 'pieChart'))) {
      if(currentChartData && currentChartData.labels && currentChartData.datasets && currentChartData.datasets[0] && Array.isArray(currentChartData.datasets[0].data) && currentChartData.datasets[0].data.length > 0) {
        currentChartData.datasets[0].data = currentChartData.datasets[0].data.slice(0,10)
        currentChartData.labels = currentChartData.labels.slice(0,10)
      }
    } else if((!isMultiChart && (chartType === 'barChart')) || (isMultiChart && (selectedTabChartData.type === 'barChart'))) {
      if(currentChartData && currentChartData.labels && currentChartData.datasets && currentChartData.datasets[0] && Array.isArray(currentChartData.datasets[0].data) && currentChartData.datasets[0].data.length > 0) {
        currentChartData.datasets[0].data = currentChartData.datasets[0].data.slice(0,10)
        currentChartData.labels = currentChartData.labels.slice(0,10)
      }
    }

    return (
      <div className={css(Styles.outerContainer)}>
        <Tabs value={selectedTabIndex}
          onChange={(event, tab) => this.handleTabChange(event, tab, {chartType})}
          variant={(tabsData[chartType] && tabsData[chartType].length > 7) ? 'scrollable' : 'fullWidth'}
          scrollButtons={(tabsData[chartType] && tabsData[chartType].length > 7) ? 'on' : 'off'}
          ScrollButtonComponent={ChartTabScrollButton}
          TabIndicatorProps={{ style: { display: 'none' }}}
          className={css(Styles.tabs)} >
          {
            tabsData[chartType].map((chart, index)=> {
              return(<Tab key={chart.reportType} disableRipple label={
                <div className={css(Styles.tabLabelContainer)}>
                  <span className={css(Styles.tabLabel1)}>{chart.title}</span>
                  <span className={css(Styles.tabLabel2)}>{chart.total}</span>
                </div>
              } classes={{ root: css(Styles.tabRoot) }} className={css(Styles.tab, selectedTabIndex === index && Styles.selectedTab)}/>)
            })
          }
        </Tabs>
        {selectedTabChartData.enableExpansion && <div className={css(Styles.expansionContainer)}>
          <Tooltip title='View Details'>
            <IconButton
              disableRipple
              className={css(Styles.icon)}
              onClick={this.openModalForViewDetails.bind(this)}
            >
              <FullscreenOutlinedIcon style={{ fontSize: 30, zIndex: 100 }}/>
            </IconButton>
          </Tooltip>
        </div>}
        {chartActions && <div className={css(Styles.chartActionsContainer)}>
          {chartActions()}
        </div>}
        {((!isMultiChart && (chartType === 'lineChart')) || (isMultiChart && (selectedTabChartData.type === 'lineChart'))) && (<LineChartCard key={chartInstanceKey} item={{
          data: currentChartData,
          xLabelsDifference}} isTabChart={true}/>)}
        {((!isMultiChart && (chartType === 'pieChart')) || (isMultiChart && (selectedTabChartData.type === 'pieChart'))) && (<PieChartCard key={chartInstanceKey} item={{
          data: currentChartData, showDataLabels}} isTabChart={true}/>)}
        {((!isMultiChart && (chartType === 'barChart')) || (isMultiChart && (selectedTabChartData.type === 'barChart'))) && (<BarChartCard key={chartInstanceKey} item={{
          data: currentChartData, showDataLabels}} isTabChart={true}/>)}
        {this.state.modalOpen ? this.renderModal() : ''}
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: AppTheme.borderRadius,
    height: '100%'
  },
  tabs: {
    height: '80px',
    backgroundColor: AppTheme.secondaryColor,
    borderTopLeftRadius: AppTheme.borderRadius,
    borderTopRightRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      marginBottom: 10
    },
  },
  scrollButton: {
    width: 40,
    height: 80,
    flexShrink: 0,
    color: '#757575',
    '@media (max-width: 1024px)': {
      width: 24,
      minWidth: 24,
      padding: 0,
    },
  },
  scrollButtonDisabled: {
    color: '#BDBDBD',
  },
  tabRoot: {
    minWidth: 'min-content',
    '@media(max-width: 767px)': {
      padding: '0 2px'
    }
  },
  tab: {
    height: '80px',
    backgroundColor: AppTheme.secondaryColor,
    borderTopLeftRadius: AppTheme.borderRadius,
    borderTopRightRadius: AppTheme.borderRadius,
    borderBottom: '1px solid ' + AppTheme.borderColor,
  },
  selectedTab: {
    backgroundColor: 'white',
    color: AppTheme.buttonBg,
    borderBottom: 0,
  },
  tabLabelContainer: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  tabLabel1: {
    textTransform: 'capitalize',
    fontSize: 18,
    fontWeight: 500,
    '@media(max-width: 767px)': {
      fontSize: 12
    },
    '@media(max-width: 360px)': {
      fontSize: 10,
    }
  },
  tabLabel2: {
    fontSize: 18,
    fontWeight: 500,
    '@media(max-width: 767px)': {
      fontSize: 12
    },
    '@media(max-width: 360px)': {
      fontSize: 10,
    }
  },
  chartActionsContainer: {
    position: 'absolute',
    bottom: 5,
    left: '50%',
    transform: 'translateX(-50%)'
  },
  expansionContainer: {
    position: 'absolute',
    top: 90,
    right: 20,
    '@media (max-width: 1024px)': {
      top: 80,
      right: 5,
    },
  },
  icon: {
    padding: 0,
    ':hover': {
      background: 'none'
    }
  },
  customRoot: {
    zIndex: 13000
  },
  customPaper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      width: '95%',
      height: 'max-content',
      maxHeight: '95%'
    },
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  modalHeader: {
    // backgroundColor: 'whitesmoke',
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14,
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: 20,
    '@media (max-width: 767px)': {
      paddingLeft: 15,
      paddingRight: 15,
    }
  },
  modalTitle: {
    color: CommonTheme.textColor,
    fontSize: 26,
    fontWeight: 600,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // marginRight: 28,
    flex: 1,
    '@media (max-width: 767px)': {
      fontSize: 20,
      marginRight: 43,
    }
  },
  modalTableContainer: {
    position: 'relative',
    maxHeight: 680,
    overflowY: 'auto',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: 30,
    paddingRight: 30,
    minHeight: 400,
    '@media (max-width: 1024px)': {
      paddingLeft: 15,
      paddingRight: 15,
      minHeight: 200,
    }
  },
  searchContainer: {
    width: '100%',
    marginBottom: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    '@media (max-width: 767px)': {
      gap: 5,
    },
  },
  searchBarWrap: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    marginTop: -8,
    marginBottom: -8,
    '@media (max-width: 767px)': {
      '& input': {
        minWidth: 0,
      },
    },
  },
  groupSelect: {
    flexShrink: 0,
    width: 250,
    height: 54,
    boxSizing: 'border-box',
    borderRadius: AppTheme.borderRadius,
    border: '1px solid #E5E5E5',
    overflow: 'hidden',
    backgroundColor: 'white',
    '@media (max-width: 767px)': {
      width: 140,
    },
  },
  groupSelectInputRoot: {
    height: 54,
    boxSizing: 'border-box',
    padding: '0 0 0 12px',
    paddingRight: 40,
    fontSize: 16,
    color: '#222222',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '& input': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  groupSelectPopupIndicator: {
    marginRight: 5,
  },
  groupSelectPopper: {
    zIndex: 130000,
  },
  groupSelectOption: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  modalCloseButton: {
    // position: 'absolute',
    // top: 23,
    // right: 30,
    padding: 0,
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
    border: 'none'
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    border: '1.5px solid' + AppTheme.primaryColor,
    fill: AppTheme.primaryColor,
    borderRadius: 8
  },
  cellHead: {
    backgroundColor: 'white',
    color: '#9B9B9B',
    height: 38,
    fontSize: 16,
    fontWeight: 'bold',
    padding: '8px 5px 8px 5px',
    textAlign: 'left',
    '@media (max-width: 767px)': {
      maxWidth: 32,
      fontSize: 10,
    },
  },
  cellBody: {
    backgroundColor: 'white',
    color: CommonTheme.textColor,
    // minHeight: 72,
    borderBottom: '1px solid ' + AppTheme.borderColor,
    fontSize: 16,
    textAlign: 'left',
    padding: '16px 5px',
    verticalAlign: 'middle',
    wordBreak: 'break-all',
    minWidth: 120,
    '@media (max-width: 767px)': {
      fontSize: 10,
      minWidth: 60,
    },
  },
  firstColumn: {
    textAlign: 'left',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200,
    width: '100%',
    '@media(max-width: 767px)': {
      maxWidth: 'unset',
      whiteSpace: 'unset',
    }
  },
  actionsColumn: {
    display: 'flex',
    justifyContent:'flex-start',
    alignItems: 'center',
    gap: 5,
    minWidth: 60,
    '@media(max-width: 1024px)': {
      minWidth: 0,
      gap: 1,
    }
  },
  drillDownEnabledCell: {
    cursor: 'pointer',
    ':hover': {
      textDecoration: 'underline',
      textDecorationColor: '#9B9B9B',
      textUnderlineOffset: 2,
    }
  },
  modalFirstColumn: {
    textAlign: 'left',
    '@media(max-width: 767px)': {
      maxWidth: 'unset',
      whiteSpace: 'unset',
    }
  },
  emptyViewContainer: {
    width: '100%',
    height: '100%',
    minHeight: 400,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media(max-width: 1024px)': {
      minHeight: 0,
    }
  },
  emptyViewText: {
    fontSize: 20,
    color: 'grey',
    '@media (max-width: 1024px)': {
      fontSize: 16,
    }
  },
})